<app-notes [moduleId]="moduleId" [entityId]="staffId" urlPrefix="/staff"></app-notes>